<template>
  <div class="my-4">
    <div class="d-flex flex-column flex-sm-row gap-3">
      <!-- Monthly Plan -->
      <label class="cp-pricing-toggle flex-fill mb-0" 
             :class="{'cp-pricing-toggle--active': isMonthly}" 
             @click="selectPlan(true)">
        <input type="radio" name="planOption" class="d-none">
        
        <div class="cp-pricing-content">
          <div class="d-flex align-items-baseline justify-content-center">
            <span class="fs-5 text-white-50 me-1">$</span>
            <h2 class="text-white font-weight-700 mb-0">{{ invitee.monthlyPrice || 10 }}</h2>
            <span class="text-white-50 font-size-13 ms-1">/mo</span>
          </div>
          <p class="text-white-50 font-size-13 mb-0 mt-1">Charged Monthly</p>
        </div>
      </label>
      
      <!-- Annual Plan -->
      <label class="cp-pricing-toggle flex-fill mb-0" 
             :class="{'cp-pricing-toggle--active': !isMonthly}" 
             @click="selectPlan(false)">
        <input type="radio" name="planOption" class="d-none">
        
        <div class="cp-pricing-badge">2 Months Free</div>
        <div class="cp-pricing-content mt-1">
          <div class="d-flex align-items-baseline justify-content-center">
            <span class="fs-5 text-white-50 me-1">$</span>
            <h2 class="text-white font-weight-700 mb-0">{{ (invitee.monthlyPrice || 10) * 10 }}</h2>
            <span class="text-white-50 font-size-13 ms-1">/yr</span>
          </div>
          <p class="text-white-50 font-size-13 mb-0 mt-1">Charged Annually</p>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "InstagramSubscription",
  props: ['invitee'],
  data() {
    return {
      isMonthly: false
    }
  },
  methods: {
    selectPlan(monthly) {
      this.isMonthly = monthly;
      this.$emit('monthly', monthly);
    }
  }
}
</script>
